<div class="order-guide-notes-section__header">
  <button
    type="button"
    class="order-guide-notes-section__toggle"
    [attr.aria-expanded]="expanded()"
    aria-controls="order-guide-notes-body"
    (click)="toggleExpanded()"
  >
    <mat-icon class="order-guide-notes-section__toggle-icon" aria-hidden="true">
      {{ expanded() ? 'expand_less' : 'expand_more' }}
    </mat-icon>
    <span class="order-guide-notes-section__title">Notes</span>
    @if (notes().length) {
      <span class="order-guide-notes-section__count">({{ notes().length }})</span>
    }
  </button>

  <button
    type="button"
    mat-mini-fab
    class="order-guide-notes-section__add-btn"
    matTooltip="Add note"
    aria-label="Add note"
    [attr.aria-expanded]="addFormVisible()"
    aria-controls="order-guide-notes-add"
    (click)="toggleAddForm($event)"
  >
    <mat-icon>add</mat-icon>
  </button>
</div>

@if (expanded()) {
  <div id="order-guide-notes-body" class="order-guide-notes-section__body">
    @if (notes().length === 0 && !isEditing) {
      <p class="note">No order guide notes.</p>
    } @else if (displayNotes().length) {
      <div class="order-guide-notes-section__list" role="table" aria-label="Order guide notes">
        <div class="order-guide-notes-section__list-header" role="row">
          <span class="order-guide-notes-section__col-note" role="columnheader">Note</span>
          <span class="order-guide-notes-section__col-user" role="columnheader">User</span>
          <span class="order-guide-notes-section__col-date" role="columnheader">Date</span>
          <span class="order-guide-notes-section__col-actions" role="columnheader">
            <span class="cdk-visually-hidden">Actions</span>
          </span>
        </div>
        <ul class="order-guide-notes-section__rows">
          @for (note of displayNotes(); track note.id) {
            <li
              class="order-guide-notes-section__row order-guide-notes-section__row--editable"
              role="row"
              tabindex="0"
              (click)="startEdit(note)"
              (keydown.enter)="startEdit(note)"
              (keydown.space)="$event.preventDefault(); startEdit(note)"
            >
              <span class="order-guide-notes-section__col-note" role="cell">{{ note.text }}</span>
              <span class="order-guide-notes-section__col-user" role="cell">{{ note.author }}</span>
              <span class="order-guide-notes-section__col-date" role="cell">{{ formatDate(note.createdOn) }}</span>
              <span
                class="order-guide-notes-section__col-actions"
                role="cell"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
              >
                <button-delete
                  [toolbar]="true"
                  matTooltip="Delete note"
                  (onClick)="removeNote(note)" />
              </span>
            </li>
          }
        </ul>
      </div>
    }

    @if (addFormVisible()) {
      <div id="order-guide-notes-add" class="order-guide-notes-section__add-row">
        <div class="order-guide-notes-section__add-field">
          <textarea
            id="order-guide-new-note"
            class="order-guide-notes-section__add-input"
            rows="2"
            data-skip-dialog-autofocus
            [formControl]="newNoteControl"
            [placeholder]="isEditing ? 'Edit note…' : 'Add a new note…'"
            [attr.aria-label]="isEditing ? 'Edit note' : 'Add a new note'"
          ></textarea>
          @if (newNoteControl.hasError('maxlength') && newNoteControl.touched) {
            <p class="order-guide-notes-section__field-error">Note text cannot exceed 4,000 characters.</p>
          }
        </div>
        <button-save
          type="button"
          [label]="submitLabel"
          [disabled]="!canSubmit"
          (onClick)="submitNote()"
        />
      </div>
    }
  </div>
}
